const URL = (process.env.REACT_APP_API_BASE_URL || "http://localhost:7100/api/").replace(/\/+$/, "") + "/";

// Mirrors admin-Imergey's constants/apiPath.js pattern — one flat object of
// endpoint strings, all relative to baseURL.
const apiPath = {
  baseURL: URL,

  // Auth
  login: "admin/auth/login",
  teamsSso: "admin/auth/teams-sso",
  forgotPassword: "admin/auth/forgot-password",
  resetPassword: "admin/auth/reset-password",
  profile: "admin/auth/profile",
  profilePicture: "admin/auth/profile/picture",

  // Employees
  employees: "admin/employees",

  // Policies
  policies: "admin/policies",
  policyTypes: "admin/policies/types",

  // Departments
  departments: "admin/departments",

  // Roles
  roles: "admin/roles",

  // Offices
  offices: "admin/offices",

  // Working Hours
  workingHours: "admin/working-hours",

  // Attendance
  attendanceDashboard: "admin/attendance/dashboard",
  attendanceCalendarSummary: "admin/attendance/calendar-summary",
  employeeActivityHistory: (employeeId) => `admin/attendance/employee/${employeeId}/activity-history`,
  employeeMonth: (employeeId) => `admin/attendance/employee/${employeeId}/month`,
  employeeCorrect: (employeeId) => `admin/attendance/employee/${employeeId}/correct`,
  employeeMonthExport: (employeeId) => `admin/attendance/employee/${employeeId}/month/export`,

  // Holidays
  holidays: "admin/holidays",
  holidaysImport: "admin/holidays/import",

  // Leave Settings
  leaveTypes: "admin/leave-settings/types",
  leavePolicies: "admin/leave-settings/policies",

  // Leave Requests
  leaveRequests: "admin/leave-requests",
  leaveBalances: "admin/leave-requests/balances",
  leaveRequestDocumentDownload: (id) => `admin/leave-requests/${id}/document/download`,

  // WFH Requests
  wfhRequests: "admin/wfh-requests",

  // Payslips (manual upload/download — still used to attach a signed PDF)
  payslips: "admin/payslips",
  payslipDownload: (id) => `admin/payslips/${id}/download`,

  // Pay Run (payroll calculation engine)
  payRunRun: "admin/pay-runs/run",
  payRuns: "admin/pay-runs",

  // Reimbursements
  reimbursements: "admin/reimbursements",
  reimbursementBillDownload: (id) => `admin/reimbursements/${id}/bill/download`,

  // Overtime
  overtime: "admin/overtime",

  // Benefits
  benefits: "admin/benefits",

  // Notifications
  notifications: "admin/notifications",
  notificationRead: (id) => `admin/notifications/${id}/read`,
  notificationReadAll: "admin/notifications/read-all",

  // Audit Logs
  auditLogs: "admin/audit-logs",

  // Web Push
  pushSubscribe: "admin/push/subscribe",
  pushUnsubscribe: "admin/push/unsubscribe",
  vapidPublicKey: "push/vapid-public-key",

  // Reports
  reportAttendance: "admin/reports/attendance",
  reportLeave: "admin/reports/leave",
  reportWfh: "admin/reports/wfh",
  reportLateArrivals: "admin/reports/late-arrivals",
  reportEarlyDepartures: "admin/reports/early-departures",
  reportGeofenceViolations: "admin/reports/geofence-violations",
  reportAutoLogouts: "admin/reports/auto-logouts",
  reportWorkingHours: "admin/reports/working-hours",
};

export default apiPath;
